module.exports = __webpack_public_path__ + "img/Rectangle 22.8824d5ee.png";